var Label_Anime = {
	init:function(){
		Debug.log("INPUT WITH LABEL INIT");
		$('input, textarea').focus(function(){
			$(this).parent().addClass('focused');
		});

		$('input, textarea').blur(function(){
			var inputValue = $(this).val();
			if ( inputValue == "" ) {
				$(this).removeClass('filled');
				$(this).parent().removeClass('focused');  
			} else {
				$(this).addClass('filled');
			}
		})  
	}
}

$(window).load(function(){
	if($("input, textarea").length){
		Label_Anime.init();
	}
})